import { render, staticRenderFns } from "./ComposerAttachmentPane.vue?vue&type=template&id=acc753e8&scoped=true"
import script from "./ComposerAttachmentPane.vue?vue&type=script&lang=js"
export * from "./ComposerAttachmentPane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc753e8",
  null
  
)

export default component.exports